import { Type } from "@angular/core";
import { NotificationHistoryChartComponent, OutstandingServiceOrdersChartComponent, PacketsProgressChartsComponent, PrepaidBillingChartComponent, PrepaidConsumptionChartComponent, QuickLinksChartComponent, SmartMeterPortalUsageChartComponent, TotalCommunityConsumptionVsMeterChartComponent, TotalMeterReportingVsMeterReportingChartComponent, UtilitiesBillCycleChartComponent, UtilitiesConnectingDisconnectingAccountsChartComponent, UtilitiesNewPacketTemplateCardComponent, UtilitiesTodoCardComponent } from "./components";

export * from "./provider";
export * from "./aggregateActionHandlers";
export * from "./components";

export * from "./enums";
export * from "./interfaces";
export * from "./services";

export const UB_CHART_COMPONENTS: Record<string, Type<unknown>> = {
    "Utilities.PacketProgressChart": PacketsProgressChartsComponent,
    "Utilities.BillCycleChart": UtilitiesBillCycleChartComponent,
    "Utilities.ConnectingDisconnectingAccountsChart": UtilitiesConnectingDisconnectingAccountsChartComponent,
    "Utilities.OutstandingServiceOrdersChart": OutstandingServiceOrdersChartComponent,
    "Utilities.NotificationHistoryChart": NotificationHistoryChartComponent,
    "Utilities.PrepaidBillingChart": PrepaidBillingChartComponent,
    "Utilities.PrepaidConsumptionChart": PrepaidConsumptionChartComponent,
    "Utilities.QuickLinksChart": QuickLinksChartComponent,
    "Utilities.SmartMeterPortalUsageChart": SmartMeterPortalUsageChartComponent,
    "Utilities.TotalCommunityConsumptionVsMeterReportingChart": TotalCommunityConsumptionVsMeterChartComponent,
    "Utilities.TotalMeterVsMeterReportingChart": TotalMeterReportingVsMeterReportingChartComponent,
    "Utilities.NewPacketTemplateCard": UtilitiesNewPacketTemplateCardComponent,
    "Utilities.TodoCard": UtilitiesTodoCardComponent
};
